import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { navigate } from 'gatsby';
import {
  CallToAction,
  Container,
  Footer,
  LandingSection,
  NotificationBellWrapper, PricingCallToActionWrapper, PricingCard, PricingTitle,
  RoadMapSection,
  Step,
  StepSection, SubTitle, SubtitleWrapper,
} from '../components/styles';
import Button from '@mui/material/Button';
import { Link } from "gatsby"
import styled from '@mui/material/styles/styled';
import yellow from '@mui/material/colors/yellow';
import grey from '@mui/material/colors/grey';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Tooltip,{ tooltipClasses } from '@mui/material/Tooltip';
import NootifyHeader from '../components/header';
import Seo from '../components/seo';


const SignUpButton = styled(Button)(({ theme }) => ({
  color:  yellow[100],
  fontSize : '17px',
  fontWeight : 600,
  width : '120px',
  margin : '10px 10px 10px 0px',
  backgroundColor: yellow[700],
  '&:hover': {
    backgroundColor: yellow[800],
  },
}));

const DocsButton = styled(Button)(({ theme }) => ({
  color : '#2C444A',
  border : '1px solid #2C444A',
  fontSize : '17px',
  fontWeight : 600,
  '&:hover': {
    backgroundColor: grey[300],
    border : '1px solid #2C444A',
  },
}));

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: yellow[700],
    color: yellow[100],
    fontSize: 13,
    fontWeight : 600
  },
}));

const IndexPage = () => {
    const [notificationActive, setNotificationActive] = React.useState(true);
    return(
      <>
        <Container>
          <Seo title={'Home'}/>
          <NootifyHeader/>
          <LandingSection>
            <CallToAction>
              <h2>Nootify API</h2>
              <NotificationBellWrapper active={notificationActive} onMouseEnter={() => setNotificationActive(false)}>
                <LightTooltip placement="top" title="Psst! Open Alpha has started, sign-up now!" arrow>
                  <NotificationsIcon/>
                </LightTooltip>
              </NotificationBellWrapper>

              <p>A lightweight notification service and API. Send and receive notifications across platforms.</p>
              <SignUpButton variant="contained" onClick={() => navigate('/auth')}>Sign Up</SignUpButton>
              <DocsButton variant="outlined" onClick={() => navigate('/docs')}>Docs</DocsButton>
            </CallToAction>
            <StaticImage
              placeholder="blurred"
              width={600}
              src={"../images/landing.jpg"} />
          </LandingSection>


          <StepSection>
            <SubtitleWrapper>
              <SubTitle>How to Join</SubTitle>
            </SubtitleWrapper>
            <Step>
              <StaticImage
                placeholder="blurred"
                height={220}
                src={"../images/signUpImage.png"} />
              <span>1. Create Account</span>
              <p>
                Sign up for our platform and get your API keys
              </p>

            </Step>
            <Step>
              <StaticImage
                placeholder="blurred"
                height={220}
                src={"../images/subscriber.png"} />
              <span>2. Subscribe</span>
              <p>
                Subscribe your apps to the service via the API
              </p>

            </Step>
            <Step>
              <StaticImage
                placeholder="blurred"
                height={220}
                src={"../images/send.png"} />
              <span>3. Send Notifications</span>
              <p>
                Send notifications to your subscribers, manage them via the Web Portal or API.
              </p>
            </Step>
          </StepSection>

          <StepSection>
            <SubtitleWrapper>
              <SubTitle>Pricing</SubTitle>
            </SubtitleWrapper>
            <PricingCard>
              <PricingTitle>
                <strong>Alpha</strong>
                <p>For Testing</p>
              </PricingTitle>
              <div>
                <h3>0$</h3>
              </div>
              <div>
                <ul>
                  <li><CheckCircleIcon fontSize={'small'}/><span> 8 Active Subscribers</span></li>
                  <li><CheckCircleIcon fontSize={'small'}/><span> 1200 Requests per day cap</span></li>
                  <li><CheckCircleIcon fontSize={'small'}/><span> 50 Requests per hour cap</span></li>
                </ul>
              </div>
              <PricingCallToActionWrapper>
                <SignUpButton size="small" variant="contained" onClick={() => navigate('/auth')}>Sign Up</SignUpButton>
              </PricingCallToActionWrapper>
            </PricingCard>

            <PricingCard variant={'free'}>
              <PricingTitle>
                <strong>Free</strong>
                <p>For personal use</p>
              </PricingTitle>
              <div>
                <h3>0$</h3>
              </div>
              <div>
                <ul>
                  <li><CheckCircleIcon fontSize={'small'}/><span> Coming soon...</span></li>
                </ul>
              </div>
              <PricingCallToActionWrapper>
              </PricingCallToActionWrapper>
            </PricingCard>

            <PricingCard variant={'premium'}>
              <PricingTitle>
                <strong>Premium</strong>
                <p>For commercial use</p>
              </PricingTitle>
              <div>
                <h3>?$</h3>
              </div>
              <div>
                <ul>
                  <li><CheckCircleIcon fontSize={'small'}/><span>Coming soon...</span></li>

                </ul>
              </div>
              <PricingCallToActionWrapper>
              </PricingCallToActionWrapper>
            </PricingCard>


          </StepSection>

          <RoadMapSection>
            <SubtitleWrapper>
              <SubTitle>Roadmap</SubTitle>
            </SubtitleWrapper>
            <p style={{fontSize : '12px'}}>
              Nootify is currently in Open Alpha. Some of the features are still in development. In the meantime, check out our roadmap for things we have planned!
            </p>
            <ul>
              <li><CheckCircleIcon style={{color :'green', marginRight : '3px'}} fontSize={'10px'}/>Open Alpha Test </li>
              <li><CheckCircleIcon style={{color :'green', marginRight : '3px'}} fontSize={'10px'}/>Web Control panel</li>
              <li><HourglassBottomIcon style={{marginRight : '3px'}} fontSize={'10px'}/> JS library for easy integration</li>
              <li><HourglassBottomIcon style={{marginRight : '3px'}} fontSize={'10px'}/> Free and paid plans</li>
              <li><HourglassBottomIcon style={{marginRight : '3px'}} fontSize={'10px'}/> ...and more!</li>
            </ul>
          </RoadMapSection>
        </Container>
        <Footer>
          <div>
            <strong>ABOUT</strong>
            <ul>
              <li><Link to={'/terms'}>Terms of Service</Link></li>
              <li><Link to={'/terms/privacy'}>Privacy Policy</Link></li>
              <li><a href={'mailto:newtifyapps@gmail.com'}>Contact</a></li>
            </ul>
          </div>
          <div>
            <strong>CREDITS</strong>
            <ul>
              <li>Developed by <a href="https://robertnc.com/">N. under NootifyApps</a></li>
              <li>Illustration by <a href="https://storyset.com/">StorySet</a></li>
            </ul>
          </div>
        </Footer>
      </>

    )
}

export default IndexPage
